module.exports = __webpack_public_path__ + "front/img/u8.0e28f37f.jpg";